import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';
import { TOOLTIP_BG_COLOR } from './consts';

export const WithIcon = styled.div`
  align-items: center;
  display: flex;
`;

export const Text = styled.div`
  padding-right: 4px;
  white-space: nowrap;
`;

export const TooltipContentCss = css`
  background-color: ${TOOLTIP_BG_COLOR};
  border-radius: 4px;
  color: ${colors.textOnInvertedStrong};
  padding: 3px 8px;
  text-align: center;
  text-overflow: ellipsis;
  max-width: 280px;
  overflow-wrap: anywhere;
`;
